module.exports = __webpack_public_path__ + "static/EC Tokenomics2-010979a4f6acea391183c79d946bb983.pdf";